import { render, staticRenderFns } from "./merchant-app-detail.vue?vue&type=template&id=007b504b&scoped=true"
import script from "./merchant-app-detail.vue?vue&type=script&lang=js"
export * from "./merchant-app-detail.vue?vue&type=script&lang=js"
import style0 from "./merchant-app-detail.vue?vue&type=style&index=0&id=007b504b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007b504b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('007b504b')) {
      api.createRecord('007b504b', component.options)
    } else {
      api.reload('007b504b', component.options)
    }
    module.hot.accept("./merchant-app-detail.vue?vue&type=template&id=007b504b&scoped=true", function () {
      api.rerender('007b504b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/develop-manage/merchant-app-detail.vue"
export default component.exports